import React, { useEffect, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { StickyBar } from 'ck-ui';
import { useMedia } from 'react-use';

const StickyNavigation = ({ anchorLink, linkName, landingRefs }) => {
  const isMobile = useMedia('(max-width: 767px)');
  const refs = useRef({});
  useEffect(() => {
    const scrollHeight = !isMobile ? 100 : 56;
    let oldElementId = '';

    const sortBy = (a, b) => {
      if (a.position > b.position) {
        return 1;
      }
      if (b.position > a.position) {
        return -1;
      }
      return 0;
    };

    const eleAndPosition = anchorLink.map(item => {
      const id = item;

      const position = landingRefs?.current[`C-${id}`]?.offsetTop;
      return {
        id,
        position
      };
    })
      .sort(sortBy);

    const removeActiveClass = () => {
      Object.keys(refs?.current).forEach((key) => {
        refs?.current[key].classList.remove('link-active');
      });
    };

    const highlightElement = scrollTop => {
      let elementId = '';
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < eleAndPosition.length - 1; i++) {
        if (
          scrollTop >= eleAndPosition[i].position
            && scrollTop < eleAndPosition[i + 1].position
        ) {
          elementId = eleAndPosition[i].id;
          break;
        } else {
          elementId = eleAndPosition[i + 1].id;
        }
      }
      if (scrollTop < eleAndPosition[0].position) {
        removeActiveClass();
        oldElementId = '';
        return;
      }
      if (oldElementId !== elementId) {
        removeActiveClass();
        refs?.current[elementId]?.classList.add('link-active');
        oldElementId = elementId;
      }
    };

    const handleScroll = () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;

      if (st >= scrollHeight) {
        highlightElement(st);
      } else {
        removeActiveClass();
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [anchorLink, isMobile, landingRefs]);

  return (
    <StickyBar zIndex={32} nonStickyHidden>
      <div className="product-nav-bar">
        {anchorLink.map((item, index) => (
          <Fragment key={item}>
            <a
              // eslint-disable-next-line no-return-assign
              ref={ele => refs.current[item] = ele}
              href={`#${item}`}
              className={classnames('product-nav-item', item)}
            >
              {linkName[index]}
            </a>
            <span className="product-nav-item-seperator">|</span>
          </Fragment>
        ))}
      </div>
    </StickyBar>
  );
};

StickyNavigation.propTypes = {
  anchorLink: PropTypes.array.isRequired,
  linkName: PropTypes.array.isRequired,
  landingRefs: PropTypes.object.isRequired,
};

export { StickyNavigation };
